export const LISTRN_RN_CALLBACK = 'LISTRN_RN_CALLBACK'
export const GET_HOT_SALES = 'GET_HOT_SALES'
export const SET_HOT_SALES = 'SET_HOT_SALES'
//设置ios完整手机号
export const SET_IOS_DECODE_PHONE = "SET_IOS_DECODE_PHONE";
//set current app verison
export const SET_APP_VERSION = 'SET_APP_VERSION';
//set current app verison Info
export const SET_APP_VER_INFO = 'SET_APP_VER_INFO';
//获取咚咚聊天链接
export const GET_DONGDONG_LINK = 'GET_DONGDONG_LINK';
//设置用户信息
export const SET_USER_INFO = 'SET_USER_INFO';
//设置用户类型值
export const SET_USER_TYPE = 'SET_USER_TYPE';
//设置用户状态值
export const SET_USER_STATE = 'SET_USER_STATE';
//设置用户身份值
export const SET_USER_IDENTITY = 'SET_USER_IDENTITY';
//设置用户邮箱
export const SET_USER_MAIL = 'SET_USER_MAIL';
//设置当前页面是否是一级页面
export const SET_IS_FIRST_LEVEL_PAGE = 'SET_IS_FIRST_LEVEL_PAGE';
//设置app是否是暗黑模式
export const SET_DARK_MODE = 'SET_DARK_MODE';
//设置是否隐藏返回头
export const SET_HIDE_HEADER = 'SET_HIDE_HEADER';


// WEBPACK FOOTER //
// ./src/store/type.js